(function(){
  var S=window.__pffSizes=window.__pffSizes||{};
  function clean(v){v=String(v||'').trim();return /default title/i.test(v)?'':v.replace(/^size\s*/i,'');}
  function grab(j){try{(j&&j.products||[]).forEach(function(p){var o=(p.options_with_values||[]).filter(function(x){return /size/i.test(x.name||x.label||'')})[0];
    if(o)S[p.id]=(o.values||[]).map(function(v){return clean(v.title)}).filter(Boolean).join(', ');});}catch(e){}}
  if(!window.__pffFetchHooked){window.__pffFetchHooked=1;var f=window.fetch;
    window.fetch=function(){var a=arguments,u=String(a[0]&&a[0].url||a[0]||'');var pr=f.apply(this,a);
      if(/bc-sf-filter\/(filter|search)/.test(u))pr.then(function(r){r.clone().json().then(function(j){grab(j);setTimeout(scan,60)}).catch(function(){})}).catch(function(){});
      return pr;};}
  function scan(){
    document.querySelectorAll('.boost-sd__product-item[data-product-id]').forEach(function(card){
      var sz=S[card.getAttribute('data-product-id')];if(!sz)return;
      var w=card.querySelector('.boost-sd__product-image-wrapper');if(!w)return;
      var el=w.querySelector('.pff-size');if(el){if(el.textContent!=='Size '+sz)el.textContent='Size '+sz;return;}
      el=document.createElement('span');el.className='pff-size';el.textContent='Size '+sz;w.appendChild(el);
    });
  }
  var t;function obs(){new MutationObserver(function(){clearTimeout(t);t=setTimeout(scan,80)}).observe(document.body,{childList:true,subtree:true});scan();}
  if(document.body)obs();else document.addEventListener('DOMContentLoaded',obs);
})();
